export default __webpack_public_path__ + "static/media/logo.a4a498c4.svg";